<template>
    <div>
        <forgot-password
            v-if="!showEmailSent"
            @show-email="showEmailSent = true"
        ></forgot-password>
        <email-sent
            v-if="showEmailSent"
            @show-email="showEmailSent = false"
        ></email-sent>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ForgotPassword from '@/components/auth/ForgotPassword.vue'
import EmailSent from '@/components/auth/EmailSent.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        ForgotPassword,
        EmailSent,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showEmailSent: false,
            formData: this.initializeFormData(),
            show: true,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'user', 'success']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the user has been updated
         *
         * @return {void}
         */
        user(value) {
            // check if the value is not empty
            // and redirect to inner page
            if (value !== null && value !== undefined) {
                this.$router.push({ name: 'view-alerts' })
            }
        }, // End of user() method
        success(value) {
            if (value) {
                this.clearFormData()
            }
        },
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                username: '',
                password: '',
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()

            if (result) {
                try {
                    // authLogin action in auth store
                    await this.$store.dispatch('authLogin', this.formData)
                    // Clear form fields
                } catch (error) {
                    //console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        }, // End of clearFormData() method
    }, // End of Component > mounted
} // End of export default
</script>
